import {
  SUCCESS_GET_RECRUITER_ACTIVITY,
  SUCCESS_MODAL_GET_RECRUITER_ACTIVITY,
  UPDATE_IS_FETCHING_RECRUITER_ACTIVITY,
  UPDATE_DISPLAY_VIEW_ALL_MODAL,
  UPDATE_HAS_MORE_ACTIVITY,
  UPDATE_IS_FETCHING_RECRUITER_ACTIVITY_MODAL
} from 'shared/actionTypes';

export default function contentRecruiterActivity(state = {}, action) {
  switch (action.type) {
    case SUCCESS_GET_RECRUITER_ACTIVITY:
      const {
        recruiterActivity,
      } = action.payload;

      return Object.assign({}, state, {
        recruiterActivity,
      });
    case SUCCESS_MODAL_GET_RECRUITER_ACTIVITY:
      const {
        modalRecruiterActivity,
      } = action.payload;
      return Object.assign({}, state, {
        ...state,
        modalRecruiterActivity
      });
    case UPDATE_IS_FETCHING_RECRUITER_ACTIVITY:
      const {
        isFetchingRecruiterActivity,
      } = action.payload;
      return Object.assign({}, state, {
        isFetchingRecruiterActivity,
      });
    case UPDATE_IS_FETCHING_RECRUITER_ACTIVITY_MODAL:
        const {
            isFetchingModalRecruiterActivity,
        } = action.payload;

        return Object.assign({}, state, {
            isFetchingModalRecruiterActivity,
        });
    case UPDATE_DISPLAY_VIEW_ALL_MODAL:
      const {
        shouldShowModal,
      } = action.payload;

      return Object.assign({}, state, {
        shouldShowViewAllModal: shouldShowModal
      });
    case UPDATE_HAS_MORE_ACTIVITY:
      const {
        hasMoreActivity,
      } = action.payload;

      return Object.assign({}, state, {
        hasMoreActivity: hasMoreActivity
      });
    default:
      return state;
  }
}
